import { Pipe, PipeTransform } from "@angular/core";
import * as moment from "moment-timezone";

@Pipe({
  name: "curantisDate",
})
export class CurantisDatePipe implements PipeTransform {
  /**
   * Takes a datetime and formats it
   */
  transform(value: string, ...args) {
    if (!value) return "";
    return moment(value).format("MM/DD/YYYY");
  }
}



// WEBPACK FOOTER //
// ./src/pipes/output-formatters/CurantisDate.ts